import React, { Component } from 'react'

import Api from '../../Services/Api'

import auth from './Auth'

export default class Logout extends Component {
    // static contextTypes = {
    //   router: React.PropTypes.object
    // }

    logout(){
      auth.logout();
    }

    componentWillMount() {
        if(auth.loggedIn()){
            this.logout()
        }else{
        //   this.context.router.push('/');
          this.props.history.push("/")
        }
    }

    render() {
        return (
            <div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/Containers/Authentication/Logout.js